import { z } from "zod";

export const coFounderSchema = z.object({
    isFounder: z.boolean().default(false),
    sharesAmount: z.number().default(0),
});

export type CoFounder = z.infer<typeof coFounderSchema>;
